"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Avatar = _interopRequireDefault(require("../../../../components/data-display/avatar/Avatar"));
var _BaseColumn = require("./support/BaseColumn");
var _components = require("../../../../components");
var _jsxRuntime = require("react/jsx-runtime");
var AvatarColumn = function AvatarColumn(_) {
  return null;
};
AvatarColumn.toColumnDef = function (child) {
  var _child$props = child.props,
    accessorKey = _child$props.accessorKey,
    image = _child$props.image,
    defaultGroupingValue = _child$props.defaultGroupingValue;
  return _objectSpread({}, (0, _BaseColumn.defaultColumnDef)(child.props), {
    accessorKey: accessorKey,
    cell: function cell(cellProps) {
      var row = cellProps.row,
        getValue = cellProps.getValue;
      var value = getValue();
      var cellValue = (0, _BaseColumn.getCellValue)(value, cellProps);
      var imageSrc = image ? image(row.original) : undefined;
      var ellipsis = !!child.props.ellipsis;
      if (!cellValue) {
        return (0, _BaseColumn.styledCell)(child.props, row.getIsGrouped() ? defaultGroupingValue : '');
      } else {
        return (0, _BaseColumn.styledCell)(child.props, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Avatar.default, {
            src: imageSrc,
            size: 's',
            name: value
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Text, {
            size: '2',
            noWrap: !ellipsis,
            ellipsis: ellipsis,
            tooltipOnEllipsis: ellipsis,
            children: cellValue
          })]
        }));
      }
    }
  });
};
var _default = exports.default = AvatarColumn;